// Imports
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import CustomSyncLoader from '../../Others/CustomSyncLoader';
import ErrorCustum from '../../Others/ErrorCustum';
import ExportPdf from '../../Exports/ExportPdf';
import CopieContent from '../../Exports/CopieContent';
import { Pagination } from 'react-bootstrap';
import { useEffect } from 'react';
import { getAllClientsparType } from '../../../Services/Facturation/FacturationClientApi';
import { addSupport, deleteSupporById, getAllSupports, updateSupport } from '../../../Services/SupportDepartment/SupportApi';
import { toast } from 'react-toastify';
import ExportCsvSupport from '../../Exports/ExportCsvSupport';
import moment from 'moment';
import ButtonHeaderComponent from '../../Styles/ButtonHeaderComponent';
import { getAllSupportclient } from '../../../Services/SupportDepartment/SupportApi';

function Listsupportclient({code_client}) {
  // Translation
  const { t } = useTranslation(); // Utilisez le hook useTranslation pour obtenir la fonction de traduction t
    //Logical part
    // States
    const [isCollapsed, setisCollapsed] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setdata] = useState([]);
    const [currentData, setcurrentData] = useState([]);
    const [size, setsize] = useState(20);
    const [clients, setClients] = useState([]);
    const [allInitialData, setallInitialData] = useState([]);
    const [startDate, setStartDate] = useState(moment().startOf('month').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(moment().endOf('month').format('YYYY-MM-DD'));
    const [selectedProject, setSelectedProject] = useState(null);
    const [clientid,setClientid]=useState()
    // Get all supports 
    useEffect(()=>{
        const id  = clients.find(item => item.code ===code_client )?.id
        if(id){
            setClientid(id)
        }
    },[clients,code_client])

    const  fetchALlSupports = async () => {
      try {
        const response = await getAllSupports()
         setcurrentData(response)
         setallInitialData(response);
        return response;
      }
      catch (err) {
        console.log(err);
      }
    }
    useEffect(()=> {
      
      fetchALlSupports()
    }, [])

    const handleStartDateChange = (e) => {
      setStartDate(e.target.value);
    };
    
    const handleEndDateChange = (e) => {
      setEndDate(e.target.value);
    };
    useEffect(()=> { 
      // Fetch the list of clients when the component mounts
      async function fetchClients() {
        try {
          const response = await getAllClientsparType();
          setClients(response.data);
          } catch (error) {
          console.error('Erreur lors de la récupération des clients :', error);
        }
      }
  
      fetchClients();
    }, [])


    

    // Projects 
    const projects = [
      "Merbiss",
      "Nomadiss",
      "Clegess"
    ]

    // Add new emty Row
    const addNewRow = () => {
      var newRow = {
          client: clientid,
          nombre_user: '',
          projet: '',
          janvier: '',
          fevrier: '',
          mars: '',
          avril: '',
          mai: '',
          juin: '',
          juillet: '',
          aout: '',
          septembre: '',
          octobre: '',
          novembre: '',
          decembre: '',
          annee: '',
          code_generated : localStorage.getItem('code_generated')
      }
      setcurrentData([
        ...currentData,
        newRow
      ])
      

    }
    const handleSelectChange = (e, index) => {
      const { value } = e.target;
      console.log("id: ", value);
      let position = e.nativeEvent.target.selectedIndex;
      let nom = e.nativeEvent.target[position].text;
      const list = [...currentData];
      list[index]["client"] = value;
      list[index]["clientName"] = nom; // Ajout de clientName
      setcurrentData(list);
      console.log(list);
    };
    
    // Handle project select
    const handleProjectSelectChange = (e, index) => {
      const { value } = e.target;
      console.log("id: ", value);
      let position = e.nativeEvent.target.selectedIndex;
      let project = e.nativeEvent.target[position].text; 
      const list = [...currentData];
      list[index]["projet"] = value;
      setcurrentData(list);
      console.log(list);
    };

    // Handle inputs change
    const onDataChange = (input, inputValue, index) => {
      console.log(inputValue);
      const list = [...currentData];
      list[index][input] = inputValue;
      setcurrentData(list);
      console.log(list);
    }


    // Delete Support By Id
    const deleteSupportById = (id, index) => {
      deleteSupporById(id).then((res) => {
        console.log(res);
        var list = currentData.filter(function(el) {
          return el.id !== id;
        });
        setcurrentData(list);
        if (res.success == 1) {
          
        }
      }).catch((err)=> {
        console.log(err);
      })

    }

      // Fetch all supports
  const fetchAllSupports = async () => {
    try {
      const response = await getAllSupportclient(code_client);
      console.log("response for all support :",response)
      setcurrentData(response);
      setallInitialData(response);
      return response;
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchAllSupports();
  }, []); 
const filterByProjetctName = async (project) => {
   if (project === "all") {
    // Si "all" est sélectionné, réinitialisez les données actuelles aux données initiales
    setcurrentData(allInitialData);
  } else {
    const filtredList = allInitialData.filter((el) => el.projet === project);
    setcurrentData(filtredList);
    setSelectedProject(project); // Mettez à jour le projet sélectionné
  }
};


    // Pagination
      /**
     * The function takes in a page of items and sets the currentData state to that page of items
     * @param pageOfItems - an array of items on the current page
     */
    const onChangePage = (pageOfItems) => {
        // update state with new page of items
        setcurrentData(pageOfItems);
    };


    const handleCollapse = () => {
        setisCollapsed(!isCollapsed);
      }; 
      const handleSaveRow = async (index) => {
        const supportToSave = currentData[index];
         // Validation: Check if a client with the same name already exists in the project
        const isDuplicateClient = currentData.some(
          (el, i) =>
            i !== index &&
            el.projet === supportToSave.projet &&
            el.client === supportToSave.client
        );
      
        if (isDuplicateClient) {
          toast.error("Vous n'avez pas le droit d'ajouter deux clients avec le même nom dans meme projet.");
          return; // Cancel the save
        }
      
        if (supportToSave.id) {
          // Updating existing row
          updateSupport(supportToSave)
            .then((res) => {
              toast.success(res.message);
            })
            .catch((err) => {
              toast.error(err);
            });
        } else {
          // Save new row
          // Handle validation
          if (supportToSave.client === "" || supportToSave.projet === "") {
            toast.error("Veuillez remplir tous les champs obligatoires: Client & Projet!.");
          } else {
            try {
              await addSupport(
                supportToSave.client,
                supportToSave.nombre_user,
                supportToSave.projet,
                supportToSave.janvier,
                supportToSave.fevrier,
                supportToSave.mars,
                supportToSave.avril,
                supportToSave.mai,
                supportToSave.juin,
                supportToSave.juillet,
                supportToSave.aout,
                supportToSave.septembre,
                supportToSave.octobre,
                supportToSave.novembre,
                supportToSave.decembre,
                supportToSave.annee
              );
      
               // You may want to handle additional logic or feedback after a successful save
            } catch (error) {
              // Handle error
              console.error("Error saving row:", error);
            }
          }
        }
      }; 
 
  const handleSearch = (e) => {
     if (e.target.value) {
      const searchKeyword = e.target.value.toLowerCase();
       const dataSearch = allInitialData.filter((el) =>
        (el.nom && el.nom.toLowerCase().includes(searchKeyword)) ||
        (el.projet && el.projet.toLowerCase().includes(searchKeyword))
      );
      setcurrentData(dataSearch);
    } else {
      setcurrentData(allInitialData);
    }
  };
  const handleSelectAllYears = () => {
    fetchAllSupports();
  };
  
  
  // const onChangeDate = () => {
  //   const filteredDate = allInitialData.filter((listed) => { 
  //     const momentDate = moment(listed.annee, 'YYYY'); // Specify the format here
  //     const isSameYear = momentDate.isSameOrAfter(moment(startDate, 'YYYY')) && momentDate.isSameOrBefore(moment(endDate, 'YYYY'));
  //      return isSameYear;
  //   });

  //   setcurrentData(filteredDate);
  // };
  const onChangeDate = (selectedYear) => {
    const filteredDate = allInitialData.filter((listed) => {
      const momentDate = moment(listed.annee, 'YYYY');
      return momentDate.isSame(moment(selectedYear, 'YYYY'));
    });
  
    setcurrentData(filteredDate);
  };

  
  const handleSelectDate = (e) => {
    const selectedYear = e.target.value;
    if (selectedYear !== '0') {
      onChangeDate(selectedYear);
    } else {
      handleSelectAllYears();
    }
  };
  
    
    // View part
  return (
    <>
     <div className="page-header d-xl-flex d-block">
        <div className="page-leftheader">
          <h4 className="page-title">{t("Département Support")}</h4>
        </div>
        <div className="page-rightheader ml-md-auto">
          <div className="align-items-end flex-wrap my-auto right-content breadcrumb-right">
            <div className="btn-list">
             
              <ButtonHeaderComponent />
            </div>
          </div>
        </div>
      </div> 
      <div className="row"> 
         <div className="col-md-4">
          <div className="form-group">
      <select className="form-control custom-select select2" onChange={handleSelectDate}>
        <option value={0}>Année</option>
        <option value={new Date().getFullYear()}>{new Date().getFullYear()}</option>
        <option value={new Date().getFullYear() - 1}>{new Date().getFullYear() - 1}</option>
        <option value={new Date().getFullYear() - 2}>{new Date().getFullYear() - 2}</option>
        <option value={new Date().getFullYear() - 3}>{new Date().getFullYear() - 3}</option>
        <option value={new Date().getFullYear() - 4}>{new Date().getFullYear() - 4}</option>
      </select>
</div>
</div>
</div>
    <div className="row mt-6">
        <div className="col-xl-12 col-md-12 col-lg-12">
          <div className={isCollapsed ? "card  card-fullscreen" : "card"}>
            <div className="card-header  border-0">
              <h4 className="card-title">{t("Département Support")}</h4>
              <div className="card-options">
                <Link to="#" className="card-options-fullscreen mr-2" data-toggle="card-fullscreen" onClick={handleCollapse}>
                  <i className="fe fe-maximize" />
                </Link>
              </div>
            </div>
            <div>
              <div className="card-container1 d-flex">
                
              <Link to="#" className='card1' onClick={()=> filterByProjetctName("Nomadiss")}>
                <h3 className='title'>Nomadiss</h3>
              </Link>
              <Link  to="#" className='card1' onClick={()=> filterByProjetctName("Clegess")}>
                <h3 className='title'>Clegess</h3>
              </Link>
              <Link to="#" className='card1' onClick={()=> filterByProjetctName("Merbiss")}>
                <h3 className='title'>Merbiss</h3>
              </Link>
              </div>
            </div>

            <div className="card-body">

              {loading && <CustomSyncLoader></CustomSyncLoader>}
              {!loading && error && <ErrorCustum></ErrorCustum>}
              {!loading && !error && data && (
                <div className="table-responsive">
                  <div id="hr-table_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                    <div className="row">
                      <div className="col-sm-12 col-md-6">
                        <div className="dataTables_length" id="hr-table_length">
                          <label>
                            {t("Afficher")}{" "}
                            <select value={8} className="form-control" id="exampleFormControlSelect1" >
                              <option value={8}>8</option>
                              <option value={20}>20</option>
                              <option value={40}>40</option>
                              <option value={60}>60</option>
                              <option value={100}>100</option>
                            </select>{" "}
                            {t("entrées")}
                          </label>
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-6">
                        <div id="hr-table_filter" className="dataTables_filter">
                           <label className="mr-2">
                            <input
                              type="search"
                              className="form-control"
                              placeholder={t("Recherche...")}
                              aria-controls="hr-table"
                              onChange={handleSearch}
                            />
                          </label>

                          <ExportCsvSupport data={currentData} name={"List_Departement_support"} />
                          <ExportPdf data={currentData} name={"List_Departement_support"} columns={["client", "projet", "nombre_user", "annee","janvier","fevrier","mars","avril","mai","juin","juillet","aout","septembre","octobre","novembre","decembre"]} />
                          <CopieContent />
                          <button className='btn btn-success' onClick={addNewRow}>
                            Ajouter Support
                          </button>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        <table
                          className="table table-vcenter text-nowrap table-bordered border-bottom dataTable no-footer"
                          id="hr-table"
                          role="grid"
                          aria-describedby="hr-table_info"
                        >
                          <thead>
                            <tr>
                              <th className="border-bottom-0 w-5 client-col">{t("Client")}</th>
                              <th className="border-bottom-0 w-5">{t("Projet")}</th>
                              <th className="border-bottom-0 w-5 ">{t("users")}</th>
                              <th className="border-bottom-0 w-5" id='an'>{t("Année")}</th>
                              <th className="border-bottom-0 w-5">{t("Janvier")}</th>
                              <th className="border-bottom-0 w-5">{t("Février")}</th>
                              <th className="border-bottom-0 w-5">{t("Mars")}</th>
                              <th className="border-bottom-0 w-5">{t("Avril")}</th>
                              <th className="border-bottom-0 w-5">{t("Mai")}</th>
                              <th className="border-bottom-0 w-5">{t("Juin")}</th>
                              <th className="border-bottom-0 w-5">{t("Juillet")}</th>
                              <th className="border-bottom-0 w-5">{t("Août")}</th>
                              <th className="border-bottom-0 w-5">{t("Septembre")}</th>
                              <th className="border-bottom-0 w-5">{t("Octobre")}</th>
                              <th className="border-bottom-0 w-5">{t("Novembre")}</th>
                              <th className="border-bottom-0 w-5">{t("Décembre")}</th>
                              <th className="border-bottom-0 w-5">{t("Action")}</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentData ? currentData.map((el, idx) => (
                              <tr key={idx} role="row" className="odd">
                              <td>
                                
                               
                                {clients.find(item => item.id == el.client)?.nom}
                              </td>
                              <td>
                              <select  onChange={(e) => handleProjectSelectChange(e, idx)} value={el.project} aria-label={el.project} className="form-control client-col" id="exampleFormControlSelect1">
                                  <option value={"default"}>{el.projet}</option>
                                  {projects.map((el) => (
                                    <>
                                  
                                    <option value={el}>{el}</option>
                                  </>
                                  ))}
                                  
                                </select>
                              </td>
                              <td >
                                <input type='text' placeholder='N°' value={el.nombre_user} onChange={(e) => onDataChange("nombre_user", e.target.value, idx)} className='inputTable'></input>
                              </td>
                              <td>
                                <input type='text' maxLength="4"  placeholder="YYYY" pattern="\d{4}" minLength="4" value={el.annee} onChange={(e) => onDataChange("annee", e.target.value, idx)}className='inputTable'></input>
                              </td>
                              <td>
                                <input type='text' placeholder='N°' value={el.janvier} onChange={(e) => onDataChange("janvier", e.target.value, idx)}className='inputTable'></input>
                              </td>
                              <td>
                                <input type='text' placeholder='N°' value={el.fevrier} onChange={(e) => onDataChange("fevrier", e.target.value, idx)}className='inputTable'></input>
                              </td>
                              <td>
                                <input type='text' placeholder='N°' value={el.mars} onChange={(e) => onDataChange("mars", e.target.value, idx)}className='inputTable'></input>
                              </td>
                              <td>
                                <input type='text' placeholder='N°' value={el.avril} onChange={(e) => onDataChange("avril", e.target.value, idx)}className='inputTable'></input>
                              </td>
                              <td>
                               <input type='text' placeholder='N°' value={el.mai} onChange={(e) => onDataChange("mai", e.target.value, idx)}className='inputTable'></input>
                              </td>
                              <td>
                                <input type='text' placeholder='N°' value={el.juin} onChange={(e) => onDataChange("juin", e.target.value, idx)}className='inputTable'></input>
                              </td>
                              <td>
                                <input type='text' placeholder='N°' value={el.juillet} onChange={(e) => onDataChange("juillet", e.target.value, idx)}className='inputTable'></input>
                              </td>
                              <td>
                                <input type='text' placeholder='N°' value={el.aout} onChange={(e) => onDataChange("aout", e.target.value, idx)}className='inputTable'></input>
                              </td>
                              <td>
                                <input type='text' placeholder='N°' value={el.septembre} onChange={(e) => onDataChange("septembre", e.target.value, idx)}className='inputTable'></input>
                              </td>
                              <td>
                                <input type='text' placeholder='N°' value={el.octobre} onChange={(e) => onDataChange("octobre", e.target.value, idx)}className='inputTable'></input>
                              </td>
                              <td>
                                <input type='text' placeholder='N°' value={el.novembre} onChange={(e) => onDataChange("novembre", e.target.value, idx)}className='inputTable'></input>
                              </td>
                              <td>
                                <input type='text' placeholder='N°' value={el.decembre} onChange={(e) => onDataChange("decembre", e.target.value, idx)}className='inputTable'></input>
                              </td>
                              <td className='d-flex align-items-center'>
                              { (currentData.length -1 == idx) ?
                                <Link
                                to="#"
                                className="text-success font-18 mr-2"
                                title="Add"
                                onClick={() => addNewRow()}
                              >
                                <i className="fa fa-plus" />
                              </Link> : <Link to="#"
                                className="text-danger font-18 mr-2 "
                                title="Remove"
                                onClick={() => deleteSupportById(el.id, idx)}>
                              <svg className='mt-1' xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="m9.4 16.5l2.6-2.6l2.6 2.6l1.4-1.4l-2.6-2.6L16 9.9l-1.4-1.4l-2.6 2.6l-2.6-2.6L8 9.9l2.6 2.6L8 15.1zM7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM7 6v13z"/></svg>
                              </Link>
                              }
                              
                                <Link
                                to="#"
                                className="text-primary font-18 mr-2"
                                title="Save"
                                onClick={() => handleSaveRow(idx)}
                              >
                                <i className="fa fa-save" />
                              </Link> 
                              
                              </td>
                              </tr>
                            )) : ''} 
                            
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-5">
                        <div className="dataTables_info" id="hr-table_info" role="status" aria-live="polite">
                          {t("Affichage de 1 à")} {size} {t("sur")} {data.length} {t("entrées")}
                        </div>
                      </div>
                      <div className="col-sm-12 col-md-7">
                        <Pagination items={data} onChangePage={onChangePage} pageSize={size} />
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

      </div>
    </>
  )
}

export default Listsupportclient;
